import { connect } from 'redux-bundler-react';
import ModalContent from '@src/app-components/modal/primary-modal/PrimaryModal.content';
import ModalFooter from '@src/app-components/modal/primary-modal/PrimaryModal.footer';

const NavigateWarningModal = connect(
  'doUpdateUrl',
  'doModalClose',
  'doSecondaryModalClose',
  ({ doUpdateUrl, doModalClose, doSecondaryModalClose, onNavigate, url, isSecondary }) => {
    const handleNavigation = () => {
      doSecondaryModalClose();
      doModalClose();
      if (onNavigate) {
        onNavigate();
        return;
      }
      doUpdateUrl(url);
    };

    return (
      <ModalContent size='md' title='Warning!'>
        <section className='modal-body'>
          <h6>
            You are about to navigate away from the data entry form; any unsaved work will be lost! <br /> <br />
            Press Cancel to go back and save your data, or OK to proceed.
          </h6>
        </section>
        <ModalFooter
          onSave={() => handleNavigation()}
          cancelText='Cancel'
          onCancel={() => (isSecondary ? doSecondaryModalClose() : doModalClose())}
          saveText='OK'
          customSaveLogic
        />
      </ModalContent>
    );
  }
);

export default NavigateWarningModal;
